export default __webpack_public_path__ + "static/media/Aller_Lt.0312903a.ttf";